import React, { useEffect, useState } from "react";

const ProctoringEventNotification = ({ event, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(!!event);

  useEffect(() => {
    if (!event) {
      setIsVisible(false);
      return;
    }

    setIsVisible(true);

    // Auto-dismiss after 3-4 seconds
    const dismissTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onDismiss?.();
      }, 300); // Wait for animation to complete
    }, 3500);

    return () => clearTimeout(dismissTimer);
  }, [event, onDismiss]);

  if (!isVisible || !event) return null;

  const getEventColor = (eventType) => {
    switch (eventType?.toLowerCase()) {
      case "face_verification_failed":
        return "bg-red-100 dark:bg-red-950 border-red-300 dark:border-red-700 text-red-700 dark:text-red-300";
      case "multiple_faces_detected":
        return "bg-orange-100 dark:bg-orange-950 border-orange-300 dark:border-orange-700 text-orange-700 dark:text-orange-300";
      case "face_occlusion_detected":
        return "bg-yellow-100 dark:bg-yellow-950 border-yellow-300 dark:border-yellow-700 text-yellow-700 dark:text-yellow-300";
      case "suspicious_activity":
        return "bg-red-100 dark:bg-red-950 border-red-300 dark:border-red-700 text-red-700 dark:text-red-300";
      default:
        return "bg-amber-100 dark:bg-amber-950 border-amber-300 dark:border-amber-700 text-amber-700 dark:text-amber-300";
    }
  };

  const getEventIcon = (eventType) => {
    switch (eventType?.toLowerCase()) {
      case "face_verification_failed":
        return "⚠️";
      case "multiple_faces_detected":
        return "👥";
      case "face_occlusion_detected":
        return "🚫";
      case "suspicious_activity":
        return "🔴";
      default:
        return "⚡";
    }
  };

return (
  <div
    className={`transition-all duration-300 ease-in-out ${
      isVisible
        ? "opacity-100 translate-y-0"
        : "opacity-0 -translate-y-1"
    }`}
  >
    <div
      className={`flex items-center justify-center gap-3
                  px-4 py-2
                  rounded-lg
                  border
                  shadow-md
                  ${getEventColor(event.event_type)}`}
    >
      {/* Icon */}
      <span className="text-base flex-shrink-0">
        {getEventIcon(event.event_type)}
      </span>

      {/* Centered Text */}
      <span className="text-sm font-semibold leading-tight text-center">
        {event.reason}
      </span>

      {/* Timestamp (optional, keep small) */}
      {event.timestamp && (
        <span className="text-xs opacity-70 whitespace-nowrap">
          {event.timestamp}
        </span>
      )}
    </div>
  </div>
);




};

export default ProctoringEventNotification;
